<template>
    <div class="row">
        <div class="col-md-12">
            <h1></h1>
            <div class="portlet light portlet-fit bordered" v-loading.body.lock="loading">
                <div class="portlet-title">
                    <div class="caption">
                        <i class="fa fa-bar-chart font-green-haze"></i>
                        <span class="caption-subject font-green-haze bold uppercase">{{ title }} by day/week/month/year</span>
                    </div>
                    <div class="actions">
                        <div class="btn-group btn-group-devided" data-toggle="buttons">
                            <label @click="$refs.chart.updateData(getDay())"
                                   :class="{active: view === 'day'}"
                                   class="btn btn-circle btn-transparent grey-salsa">
                                <input type="radio" name="options" class="toggle">Day</label>
                            <label @click="$refs.chart.updateData(getWeek())"
                                   :class="{active: view === 'week'}"
                                   class="btn btn-circle btn-transparent grey-salsa">
                                <input type="radio" name="options" class="toggle">Week</label>
                            <label @click="$refs.chart.updateData(getMonth())"
                                   :class="{active: view === 'month'}"
                                   class="btn btn-circle btn-transparent grey-salsa">
                                <input type="radio" name="options" class="toggle">Month</label>
                            <label @click="$refs.chart.updateData(getYear())"
                                   :class="{active: view === 'year'}"
                                   class="btn btn-circle btn-transparent grey-salsa">
                                <input type="radio" name="options" class="toggle">Year</label>
                        </div>
                    </div>
                </div>
                <div class="portlet-body">
                    <v-line-area-chart
                            ref="chart"
                            :options="options">
                    </v-line-area-chart>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  /* ============
   * User Metrics Component
   * ============
   *
   */
  import VPortlet from '@/app/components/Portlet'
  import VLineAreaChart from '@/app/components/charts/LineArea'

  export default {
    props: {
      provider: {
        type: Object,
        required: true
      },
      title: {
        type: String
      },
      categoryField: {
        type: String,
        default: 'dt'
      },
      color: {
        type: String,
        default: '#9b59b6'
      }
    },
    components: {
      VPortlet,
      VLineAreaChart
    },
    data () {
      return {
        loading: true,
        stats: [],
        view: 'day',
        options: {
          'type': 'serial',
          'categoryField': this.categoryField,
          'startDuration': 1,
          'categoryAxis': {
            'gridPosition': 'start',
            'axisAlpha': 0,
            'tickLength': 0,
            'parseDate': false
          },
          'valueAxes': [{
            'axisAlpha': 0,
            'position': 'left'
          }],
          'chartCursor': {
            'enabled': true
          },
          'chartScrollbar': {
            'enabled': true
          },
          'trendLines': [],
          'guides': [],
          'allLabels': [],
          'balloon': {},
          'theme': 'light',
          'pathToImages': '/static/plugins/amcharts/images/',
          'autoMargins': false,
          'marginLeft': 50,
          'marginRight': 8,
          'marginTop': 10,
          'marginBottom': 50,
          'fontFamily': 'Open Sans',
          'color': '#888',
          'graphs': [{
            'alphaField': 'alpha',
            'balloonText': '<span style=\'font-size:13px;\'>[[title]] in [[category]] : <b>[[value]]</b> [[additional]]</span>',
            'dashLengthField': 'dashLengthColumn',
            'fillAlphas': 1,
            'title': this.title,
            'type': 'column',
            'valueField': 'value',
            'fillColors': this.color,
            'lineColor': this.color
          }]
        }
      }
    },
    computed: {},
    methods: {
      getStats () {
        const provider = this.provider
        return provider.all()
      },
      getYear () {
        this.rotateLabels(15)
        this.view = 'year'
        return this.stats['12months']
      },
      getMonth () {
        this.rotateLabels(15)
        this.view = 'month'
        return this.stats['31days']
      },
      getWeek () {
        this.rotateLabels(15)
        this.view = 'week'
        return this.stats['31days'].slice(Math.max(this.stats['31days'].length - 7, 1))
      },
      getDay () {
        this.rotateLabels()
        this.view = 'day'
        return this.stats['24hrs']
      },
      rotateLabels (angle = null) {
        if (angle) {
          this.options.categoryAxis.labelRotation = angle
          this.options.categoryAxis.labelOffset = 10
        } else {
          this.options.categoryAxis.labelRotation = 0
          this.options.categoryAxis.labelOffset = 0
        }
      },
      updateChart () {
        this.getStats().then(res => {
          this.stats = JSON.parse(res.data['data'])
          this.loading = false
          let fn = this.getMonth
          switch (this.view) {
            case 'day':
              fn = this.getDay
              break
            case 'week':
              fn = this.getWeek
              break
            case 'month':
              fn = this.getMonth
              break
            case 'year':
              fn = this.getYear
              break
          }
          if (this.$refs.chart) {
            this.$refs.chart.updateData(fn())
          }
        }).catch(err => {
          this.loading = false
          console.log(err.message)
          this.$notify.error({
            title: 'Error',
            message: err.message
          })
        })
      }
    },
    mounted () {
      this.updateChart()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/metrics/BaseLineChart.vue